import Service from "../../services";

const statusModule = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async exportTest({ commit }) {
      return Service.test.exportTest();
    },
    async exportSetTest({ commit }) {
      return Service.test.exportSetTest();
    },
    async exportTest({ commit }) {
      return Service.test.exportTest();
    },
    async getPermissionList({ commit }) {
      return Service.permission.getPermissionList();
    },
    async getUserGroupList({ commit }) {
      return Service.permission.getUserGroupList();
    },
    async setUserGroupList({ commit }, data) {
      return Service.permission.setUserGroupList(data.id, data.payload);
    },
    async getUserList({ commit }, data) {
      return Service.user.getUserList();
    },
    async createUser({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.user.createUser(data, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateUser({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.user.updateUser(data.payload, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteUser({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.user.deleteUser(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getSpeciesList({ commit }) {
      return Service.species.getSpecies();
    },
    async updateSpecies({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.species.updateSpecies(
          data.payload,
          data.id,
          token
        );
      } else {
        throw { message: "password incorrect" };
      }
    },
    async createSpecies({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.species.createSpecies(data, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteSpecies({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.species.deleteSpecies(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getBreedList({ commit }) {
      return Service.breed.getSettingBreed();
    },
    async createBreed({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.breed.createSettingBreed(data, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateBreed({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.breed.updateSettingBreed(
          data.payload,
          data.id,
          token
        );
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteBreed({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.breed.deleteSettingBreed(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getRemarkList({ commit }) {
      return Service.result.getSettingRemark();
    },
    async createRemark({ commit }, payload) {
      let confirmPassword = await Service.auth.confirmPassword(payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.result.createSettingRemark(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateRemark({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.result.updateSettingRemark(data.payload, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteRemark({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.result.deleteSettingRemark(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getItemList({ commit }) {
      return Service.item.getSettingItem();
    },
    async createItem({ commit }, payload) {
      let confirmPassword = await Service.auth.confirmPassword(payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.item.createSettingItem(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateItem({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.item.updateSettingItem(data.payload, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteItem({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.item.deleteSettingItem(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getTestTypeList({ commit }) {
      return Service.test.getSettingTestType();
    },
    async createTestType({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.createSettingTestType(data.payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSequenceTestType({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSequenceTestType(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSequenceTest({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSequenceTest(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSequenceSubTest({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSequenceSubTest(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateTestType({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSettingTestType(data.payload, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteTestType({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.deleteSettingTestType(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getTestList({ commit }) {
      return Service.test.getSettingTest();
    },
    async createTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.createSettingTest(data, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSettingTest(data, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.deleteSettingTest(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getSubTestList({ commit }) {
      return Service.test.getSettingSubTest();
    },
    async getSubTestListByTestId({ commit }, id) {
      return Service.test.getSettingSubTestByTestId(id);
    },
    async getSubTestListBySubTestId({ commit }, id) {
      return Service.test.getSettingSubTestBySubTestId(id);
    },
    async createSubTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.createSettingSubTest(data, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSubTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSettingSubTest(data, data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteSubTest({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.deleteSettingSubTest(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getMachine({ commit }) {
      return Service.test.getMachine();
    },
    async fetchUserHistory({ commit }, filters) {
      return Service.user.fetchUserHistory(filters);
    },
    async getTestByTestTypeId({ commit }, id) {
      return Service.test.getTestByTestTypeId(id);
    },
    async getUnits({ commit }) {
      return Service.test.getUnits();
    },
    async updateUnit({ commit }, { id, payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateUnit(id, payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async createUnit({ commit }, { id, payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.createUnit(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteUnit({ commit }, { id, payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.deleteUnit(id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getPromotions({ commit }, query = []) {
      return Service.account.getPromotions(query);
    },
    async getPromotionById({ commit }, id) {
      return Service.account.getPromotionById(id);
    },
    async createPromotion({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.account.createPromotion(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updatePromotion({ commit }, { id, payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.account.updatePromotion(id, payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deletePromotion({ commit }, { id, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.account.deletePromotion(id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSetTest({ commit }, payload) {
      let confirmPassword = await Service.auth.confirmPassword(payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSetTest(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getPriceGroupByTestId({ commit }, id) {
      return Service.test.getPriceGroupByTestId(id);
    },
    async getPriceGroupBySetTestId({ commit }, id) {
      return Service.test.getPriceGroupBySetTestId(id);
    },
    async updateTestPriceGroup({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateTestPriceGroup(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateSetTestPriceGroup({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.test.updateSetTestPriceGroup(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async getDirections({ commit }) {
      return Service.hospital.getDirections();
    },
    async getDirection({ commit }, id) {
      return Service.hospital.getDirection(id);
    },
    async createDirection({ commit }, { payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.hospital.createDirection(payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async updateDirection({ commit }, { id, payload, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.hospital.updateDirection(id, payload, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async deleteDirection({ commit }, { id, password }) {
      let confirmPassword = await Service.auth.confirmPassword({ password });

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return Service.hospital.deleteDirection(id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
  },
  getters: {},
};
export default statusModule;
